import { useSelector } from "react-redux";
import { Get, Post } from "../AxiosCRUDFunctions";
import { apiHeader, BaseURL } from "../config";
import moment from "moment-timezone";
import { Appversion } from "../data/index";
const useApi = () => {
  const { accessToken, communityId } = useSelector(
    (state) => state?.authReducer
  );

  const { deviceToken } = useSelector((state) => state?.FCMReducer);

  const login = async ({
    code,
    phoneNumber,
     userName,
    password,
    deviceToken,
    version,
  }) => {
    const response = await Post(
      BaseURL("Auth/login"),
      {
        // countryCode: code,
        // cellNumber: phoneNumber,
        userName,
        password: password,
        deviceToken,
        version,
      },
      apiHeader()
    );
    return response;
  };

  const logout = async (deviceToken) => {
    const response = await Post(
      BaseURL("Auth/logout"),
      { deviceToken },
      apiHeader(accessToken)
    );
    return response;
  };

  const RequestForgotOTP = async (body) => {
    const response = await Post(
      BaseURL("Auth/SendOTPForgot"),
      body,
      apiHeader(body?.accessToken)
    );
    return response;
    return;
  };

  const resetPassword = async (body) => {
    // const response = await Post(
    //   BaseURL("Auth/resetPassword"),
    //   body,
    //   apiHeader(accessToken)
    // );
    // return response;
    return;
  };

  const signUp = async ({
    name,
    code,
    phoneNumber,
    email,
    password,
    communityName,
    communityAddress,
    token,
  }) => {
    const response = await Post(
      BaseURL("Auth/Register"),
      {
       fullUserName: name,
        // countryCode: code,
        cellNo: "00",
        email,
        password,
        // communityName,
        // communityAddress,
        deviceToken,
      },
      apiHeader(token)
    );
    return response;
  };

  const joinCommunity = async (data) => {
    const response = await Post(
      BaseURL("Community/JoinCommunity"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const generateOtp = async ({ userName}) => {
    const response = await Post(
      BaseURL("Auth/SendOTPSignup"),
      {
        userName,
      },
      apiHeader()
    );
    return response;
  };

  const verifyOtp = async ({ otpCode }) => {
    const response = await Post(
      BaseURL("Auth/verify-otp"),
      {
        otpCode: otpCode,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const ForgotPassword = async (body) => {
    const response = await Post(
      BaseURL("Auth/ForgotPassword"),
      body,
      apiHeader(accessToken)
    );
    return response;
  };

  const verifyCommunity = async ({ code }) => {
    const response = await Post(
      BaseURL("Community/VerifyCommunity"),
      {
        communityCode: code,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const SaveAmmenityRanges = async (form) => {
    const response = await Post(
      BaseURL("Community/SaveAmmenityRanges"),
      form,
      apiHeader(accessToken)
    );
    return response;
  };

  const UploadAmmenitySeriesExcel = async ({ formData, communityId }) => {
    const response = await Post(
      BaseURL(`Community/UploadAmmenitySeriesExcel?CommunityId=${communityId}`),
      formData,
      apiHeader(accessToken, true)
    );
    return response;
  };

  const DownloadAmmenitySeriesExcel = async ({ communityId }) => {
    const response = await Get(
      BaseURL(
        `Community/DownloadAmmenitySeriesExcel?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetAllAmmenities = async () => {
    const response = await Get(BaseURL("Setup/GetAllAmmenities"), accessToken);
    return response;
  };

  const GetAllAmmenitiesWithCount = async () => {
    const response = await Get(
      BaseURL(`Setup/GetAllAmmenityWithCount?CommunityId=${communityId}`),
      accessToken
    );
    return response;
  };

  const GetAllPropertyType = async () => {
    const response = await Get(
      BaseURL("Setup/GetAllPropertyType"),
      accessToken
    );
    return response;
  };

  const GetUserDetailsByCellno = async (number) => {
    const encodedPhone = encodeURIComponent(`${number?.trim()}`);
    const response = await Get(
      BaseURL(
        `user/GetUserByCellNo?CommunityId=${communityId}&CellNo=${encodedPhone}`
      ),
      accessToken
    );
    return response;
  };

  const GetAmmenityDetailBySeriesDetailId = async ({ id }) => {
    const response = await Get(
      BaseURL(
        `Community/GetAmmenityDetailBySeriesDetailId?CommunityId=${communityId}&communitySeriesDetailId=${id}`
      ),
      accessToken
    );
    return response;
  };

  const GetAllRole = async (id) => {
    const response = await Get(
      BaseURL(`Role/GetAllRole?CommunityId=${id}`),
      accessToken
    );
    return response;
  };

  const GetAllDesignations = async () => {
    const response = await Get(BaseURL("Setup/GetAllDesignation"), accessToken);
    return response;
  };

  const allotParking = async (data) => {
    const response = await Post(
      BaseURL("Ammenity/AllotParking"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const addBooking = async ({ data }) => {
    const response = await Post(
      BaseURL("Booking/CreateBooking"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const addUser = async ({ data }) => {
    const response = await Post(
      BaseURL("user/add-user"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const updateUser = async ({ data }) => {
    const response = await Post(
      BaseURL("user/update-user"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const addUserWithAmmenity = async ({ data }) => {
    const response = await Post(
      BaseURL("user/AddUserAndAmmenityMapping"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const updateUserWithAmmenity = async ({ data }) => {
    const response = await Post(
      BaseURL("user/UpdateUserAndAmmenityMapping"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const addUserWithRole = async ({ data }) => {
    const response = await Post(
      BaseURL("user/AddUserAndRole"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const updateUserWithRole = async ({ data }) => {
    const response = await Post(
      BaseURL("user/UpdateUserAndRole"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const getAllSeriesByCommunity = async (id) => {
    const response = await Get(
      BaseURL(`Setup/GetAllSeriesByCommunityId?CommunityId=${id}`),
      accessToken
    );
    return response;
  };

  const getAllSeriesByCommunityWithGroup = async (id) => {
    const response = await Get(
      BaseURL(`Setup/GetAllSeriesByCommunityIdWithGroup?CommunityId=${id}`),
      accessToken
    );
    return response;
  };

  const getAmenitySeriesByAmenityId = async (ammenityId) => {
    const response = await Get(
      BaseURL(
        `Setup/GetAllSeriesByCommunityIdAndAmmenityIDWithGroup?CommunityId=${communityId}&AmmenityId=${ammenityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetSingleAmenityListById = async (ammenityId) => {
    const response = await Get(
      BaseURL(
        `Setup/GetByCommunityIdAndAmmenityId?CommunityId=${communityId}&AmmenityId=${ammenityId}`
      ),
      accessToken
    );
    return response;
  };

  const SaveAmenitySettings = async (data) => {
    const response = await Post(
      BaseURL("Setting/SaveAmmenitySettings"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  // const getAllParkingSeriesWithGroup = async (id) => {
  //   const response = await Get(
  //     BaseURL(`Setup/GetAllParkingSeriesWithGroup?CommunityId=${id}`),
  //     accessToken
  //   );
  //   return response;
  // };

  const GetAllApprovalsListing = async (data) => {
    const response = await Post(
      BaseURL("Approval/GetApprovalRequestList"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetApprovalById = async (id) => {
    const response = await Get(
      BaseURL(
        `Approval/GetByApprovalRequestID?CommunityId=${communityId}&ApprovalRequestId=${id}`
      ),
      accessToken
    );
    return response;
  };

  const handleApprovalRequest = async ({ data }) => {
    const response = await Post(
      BaseURL("Approval/ApproveByApprovalRequestId"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllRoleListing = async ({ data }) => {
    const response = await Post(
      BaseURL("Role/GetRoleList"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllRoleModules = async (id) => {
    const response = await Get(
      BaseURL(`Role/GetAllModules?CommunityId=${id}`),
      accessToken
    );
    return response;
  };

  const GetRoleById = async ({ id }) => {
    const response = await Get(BaseURL(`Role/GetByID?ID=${id}`), accessToken);
    return response;
  };

  const SaveRolePermission = async ({ data }) => {
    const response = await Post(
      BaseURL("Role/savePermissions"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const UpdateRolePermission = async ({ data }) => {
    const response = await Post(
      BaseURL("Role/updatePermissions"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const getAllAnnouncementListing = async ({ data }) => {
    const response = await Post(
      BaseURL("Announcement/GetAnnouncementList"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const getProfileAnnouncementListing = async ({ data }) => {
    const response = await Post(
      BaseURL("Announcement/GetProfileAnnouncementList"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const creatAnnouncement = async ({ data }) => {
    const response = await Post(
      BaseURL("Announcement/AddAnnouncement"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllApprovalStatusListing = async () => {
    const response = await Get(
      BaseURL("Setup/GetAllApprovalStatus"),
      accessToken
    );
    return response;
  };
  const getAnnouncementById = async (id) => {
    const response = await Post(
      BaseURL(`Announcement/GetAnnouncementById?AnnouncementId=${id}`),
      {},
      apiHeader(accessToken)
    );

    return response;
  };

  const addOrEditAnnouncement = async (selectedData, params) => {
    const response = await Post(
      BaseURL(
        `Announcement/${selectedData != null ? "UpdateAnnouncement" : "AddAnnouncement"
        }`
      ),
      params,
      apiHeader(accessToken)
    );

    return response;
  };
  const deleteAnnouncement = async ({ id, communityId }) => {
    const response = await Post(
      BaseURL("Announcement/DeleteAnnouncement"),
      { announcementId: id, communityId },
      apiHeader(accessToken)
    );
    return response;
  };
  // communityservices start from here
  const getAllCommunityServiceListing = async (params) => {
    const response = await Post(
      BaseURL("CommunityService/GetServicesList"),
      params,
      apiHeader(accessToken)
    );
    return response;
  };
  const getCommunityServiceById = async (id) => {
    const response = await Post(
      BaseURL(`CommunityService/GetServicesById?ServiceCategoryId=${id}`),
      {},
      apiHeader(accessToken)
    );

    return response;
  };
  const addOrEditCommunityService = async (selectedData, params) => {
    const response = await Post(
      BaseURL(
        `CommunityService/${selectedData ? "UpdateService" : "AddService"}`
      ),
      params,
      apiHeader(accessToken)
    );
    return response;
  };
  const deleteCommunityServiceCategory = async (id) => {
    const response = await Post(
      BaseURL("CommunityService/DeleteServiceCategory"),
      { serviceCategoryId: id },
      apiHeader(accessToken)
    );
    return response;
  };

  const deleteCommunityService = async (params) => {
    const response = await Post(
      BaseURL("CommunityService/DeleteService"),
      params,
      apiHeader(accessToken)
    );
    return response;
  };

  const getAllServicesType = async (params) => {
    const response = await Get(BaseURL("Setup/GetAllServiceType"), accessToken);
    return response;
  };

  const getUserDetails = async (id) => {
    const response = await Get(
      BaseURL(`Profile/GetUserProfile?CommunityId=${id}`),
      accessToken
    );
    return response;
  };

  const getUserByRoleId = async (id) => {
    const response = await Get(
      BaseURL(
        `user/GetAllUsersByRoleId?CommunityId=${communityId}&RoleId=${id}`
      ),
      accessToken
    );
    return response;
  };

  const GetAllUserListing = async (data) => {
    const response = await Post(
      BaseURL("user/GetUserList"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllBookingListing = async (data) => {
    const response = await Post(
      BaseURL("Booking/AmmenityBookingList"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const UpdateUserAccess = async (data) => {
    const response = await Post(
      BaseURL("user/update-user-role"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const SaveCommunityDetails = async (data) => {
    const response = await Post(
      BaseURL("Community/CreateCommunity"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const ChangePassword = async (data) => {
    const response = await Post(
      BaseURL("Profile/ChangePassword"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const UpdateProfile = async (data) => {
    const response = await Post(
      BaseURL("Profile/UpdateProfileSetting"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllAmmenitiesListing = async (id) => {
    let commId = id;
    if (!id) {
      commId = communityId;
    }
    const response = await Get(
      BaseURL(
        `Setup/GetAllAmmenitiesByCommunityIdWithGroup?CommunityId=${commId}`
      ),
      accessToken
    );
    return response;
  };

  const GetUserDetailByUserDetailId = async ({ id }) => {
    const response = await Get(
      BaseURL(
        `user/GetUserByUserDetailId?CommunityId=${communityId}&UserDetailId=${id}`
      ),
      accessToken
    );
    return response;
  };

  const AddFinancialYear = async (data) => {
    const response = await Post(
      BaseURL("FinancialTransaction/SaveOpeningBalanceCash"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const AddNewBankAccount = async (data) => {
    const response = await Post(
      BaseURL("FinancialTransaction/SaveOpeningBalanceBank"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllAccountsListing = async () => {
    const response = await Get(
      BaseURL(
        `FinancialTransaction/GetAllTransactionAccountWithBalance?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetAllAccountsBankAndCash = async () => {
    const response = await Get(
      BaseURL(
        `FinancialTransaction/GetAllAccountsBankAndCash?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetAllAccountsBankAndCashWithWallet = async () => {
    const response = await Get(
      BaseURL(
        `FinancialTransaction/GetAllAccountsBankAndCashWithWallet?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetSingleAccountDetails = async ({ data }) => {
    console.log("Data",data)
    const { accountCode, toDate, fromDate } = data;
    const response = await Get(
      BaseURL(
        `FinancialTransaction/GetAllTransactionsByAccountCode?CommunityId=${communityId}&AccountCode=${accountCode}&FromDate=${fromDate}&ToDate=${toDate}`
      ),
      accessToken
    );
    return response;
  };

  const CheckCashAccountOpen = async () => {
    const response = await Get(
      BaseURL(`Setup/CheckCashOpeningBalance?CommunityId=${communityId}`),
      accessToken
    );
    return response;
  };

  const GetAllTransactionAccountsForDropdown = async () => {
    const response = await Get(
      BaseURL(
        `FinancialTransaction/GetAllTransactionAccounts?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const transferFunds = async (data) => {
    const response = await Post(
      BaseURL("FinancialTransaction/TransferFund"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllExpenseListing = async () => {
    const response = await Get(
      BaseURL(
        `Expense/GetAllTransactionExpenseAccountWithBalance?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetSingleExpenseDetails = async (code) => {
    const response = await Get(
      BaseURL(
        `Expense/GetAllExpenseSubCategoryByParentAccountCode?CommunityId=${communityId}&AccountCode=${code}`
      ),
      accessToken
    );
    return response;
  };

  const AddNewExpenseCategory = async (data) => {
    const response = await Post(
      BaseURL("Expense/SaveExpenseCategory"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const AddNewExpenseSubCategory = async (data) => {
    const response = await Post(
      BaseURL("Expense/SaveExpenseSubCategory"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const AddNewExpense = async (data) => {
    const response = await Post(
      BaseURL("Expense/SaveExpense"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllSeriesByCIdAIdMonthYear = async (data) => {
    const { ammenityId, month, year } = data;
    const response = await Get(
      BaseURL(
        `Setup/GetAllSeriesByCommunityIdAmmenityIdMonthYearWithGroup?CommunityId=${communityId}&AmmenityId=${ammenityId}&Year=${year}&Month=${month}`
      ),
      accessToken
    );
    return response;
  };

  const GetMaintenanceCollectionListing = async (ammenityId) => {
    const response = await Get(
      BaseURL(
        `PaymentCollection/GetListingForMaintenanceCollection?CommunityId=${communityId}&AmmenityId=${ammenityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetMonthYearForDropdown = async () => {
    const response = await Get(
      BaseURL("Setup/GetAllMonthAndYear"),
      accessToken
    );
    return response;
  };

  const GenerateMaintenance = async (data) => {
    const response = await Post(
      BaseURL("PaymentCollection/GenerateMaintenance"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const SubmitMaintenanceCollection = async (data) => {
    const response = await Post(
      BaseURL("PaymentCollection/MaintenanceCollection"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetMaintenanceDetails = async (data) => {
    const { ammenityId, communitySeriesDetailID } = data;
    const response = await Get(
      BaseURL(
        `PaymentCollection/GetMaintenanceDetailByCommunitySeriesDetailID?CommunityId=${communityId}&CommunitySeriesDetailID=${communitySeriesDetailID}`
      ),
      accessToken
    );
    return response;
  };

  const GetTransactionDetails = async (data) => {
    const { seriesDetailId, status } = data;

    const response = await Get(
      // GetAllTransactionsByCommunityIDAndSeriesDetailID?CommunityId=${communityId}&CommunitySeriesDetailId=${communitySeriesDetailId}&ApprovalStatusId=${status}
      BaseURL(
        `FinancialTransaction/GetAllTransactionsByCommunityIDAndSeriesDetailIDAndStatusID?CommunityId=${communityId}&SeriesDetailId=${seriesDetailId}&ApprovalStatusId=${status}`
      ),
      accessToken
    );
    return response;
  };

  const PaymentCollectionForBooking = async (data) => {
    const response = await Post(
      BaseURL("Booking/PaymentCollectionForBooking"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllVisitorListing = async (data) => {
    const response = await Post(
      BaseURL("Visitor/GetVisitorListing"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetVisitorListByCommunitySeriesDetailId = async (data) => {
    const response = await Post(
      BaseURL("Visitor/GetReceptionVisitorListing"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const GetVisitorDetailByVisitorId = async ({ id }) => {
    const response = await Get(
      BaseURL(
        `user/GetUserByUserDetailId?CommunityId=${communityId}&UserDetailId=${id}`
      ),
      accessToken
    );
    return response;
  };

  const UpdateVisitStatusToArrived = async (id) => {
    const response = await Post(
      BaseURL(`Visitor/VisitorArrived`),
      {
        communityId,
        visitorId: id,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const UpdateVisitStatusToExit = async (id) => {
    const response = await Post(
      BaseURL(`Visitor/VisitorExit`),
      {
        communityId,
        visitorId: id,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const addVisitor = async ({ data }) => {
    const response = await Post(
      BaseURL("Visitor/AddVisitor"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const updateVisitor = async ({ data }) => {
    // const response = await Post(
    //   BaseURL("user/update-user"),
    //   data,
    //   apiHeader(accessToken)
    // );
    // return response;
  };

  const getAllStates = async () => {
    const response = await Get(
      BaseURL(`Setup/GetAllStateByCountryId?CountryId=${1}`),
      accessToken
    );
    return response;
  };

  const getAllCitiesByStateId = async (id) => {
    const response = await Get(
      BaseURL(`Setup/GetAllCityByStateId?StateId=${id}`),
      accessToken
    );
    return response;
  };

  const getDashboardStats = async (id) => {
    const response = await Get(
      BaseURL(`Dashboard/GetDashboardCardCount?CommunityID=${communityId}`),
      accessToken
    );
    return response;
  };

  const VerifyWaitList = async (data) => {
    const response = await Post(
      BaseURL("Auth/verifyWaitlistCode"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const requestWaitListCode = async (data) => {
    const response = await Get(
      BaseURL("Auth/RequestWaitListCode"),
      accessToken
    );
    return response;
  };

  const waitListVerificationApi = async (id) => {
    const response = await Get(
      BaseURL(`Auth/WaitListVerification`),
      accessToken
    );
    return response;
  };

  const getResidentPaymentsListing = async (ammenityId) => {
    const response = await Get(
      BaseURL(
        `PaymentCollection/GetListingBankPaymentForUser?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  // const getMyPaymentsListing = async (data) => {
  //   const response = await Get(
  //     BaseURL(
  //       `PaymentCollection/GetMyPaymentListing?CommunityId=${communityId}`
  //     ),
  //     accessToken
  //   );
  //   return response;
  // };

  const getMyPaymentsListing = async (data) => {
    const response = await Get(
      BaseURL(
        `PaymentCollection/GetMyPaymentListing_New?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const SubmitResidentPaymentCollectionHandler = async (data) => {
    const response = await Post(
      BaseURL("BankPayment/BankPayment"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetNotificationsList = async (data) => {
    const response = await Post(
      BaseURL("Notification/get-notifications"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetAllPackages = async () => {
    const response = await Get(
      BaseURL("Subscription/GetApplicationPackage"),
      accessToken
    );
    return response;
  };
  const GetPackageDetails = async () => {
    const response = await Get(
      BaseURL(`Subscription/GetSubscription?communityId=${communityId}`),
      accessToken
    );
    return response;
  };

  const PayNowHandler = async (data) => {
    const response = await Post(
      BaseURL("Subscription/AddSubscriptionPayNow"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const PayLaterHandler = async (data) => {
    const response = await Post(
      BaseURL("Subscription/AddSubscriptionPayLater"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const VerifyPayment = async (cId, id) => {
    const response = await Get(
      BaseURL(
        `Subscription/GetSubscriptionById?communityId=${cId}&subscriptionId=${id}`
      ),
      accessToken
    );
    return response;
  };

  // Complain Apis

  const GetAllComplainStatusListing = async () => {
    const response = await Get(
      BaseURL("Setup/GetAllComplainStatus"),
      accessToken
    );
    return response;
  };

  const GetAllComplainTypeListing = async () => {
    const response = await Get(
      BaseURL("Setup/GetAllComplainRequestType"),
      accessToken
    );
    return response;
  };

  const addComplainHandler = async (data) => {
    const response = await Post(
      BaseURL("Complain/AddComplain"),
      data,
      apiHeader(accessToken, true)
    );
    return response;
  };

  const GetAllComplainsListing = async (data) => {
    const response = await Post(
      BaseURL("Complain/GetComplainListing"),
      data,
      apiHeader(accessToken)
    );
    return response;
  };

  const UpdateComplainStatus = async (complainId, statusId) => {
    const response = await Post(
      // BaseURL(`Complain/ChangeComplainStatus`),
      BaseURL(`Complain/ChangeComplainStatus_New`),
      {
        complainId: complainId,
        statusId: statusId,
        communityId
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetComplainById = async (id) => {
    const response = await Get(
      BaseURL(`Complain/GetComplainById?complainId=${id}`),
      accessToken
    );
    return response;
  };

  const AddCommunityPolicy = async (data) => {
    const response = await Post(
      BaseURL("CommunityPolicy/AddCommunityPolicy"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const GetCommunityPolicy = async () => {
    const response = await Get(
      BaseURL(
        `CommunityPolicy/GetCommunityPolicyByCommunityId?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const GetAutoGenerateDropdown = async () => {
    const response = await Get(
      BaseURL(`Setup/GetDropdownForAutoGenerateBill`),
      accessToken
    );
    return response;
  };

  const GetNotificationDropdown = async () => {
    const response = await Get(
      BaseURL(`Setup/GetDropdownForNotification`),
      accessToken
    );
    return response;
  };

  const SaveAdditionalSettings = async (data) => {
    const response = await Post(
      BaseURL("Setting/SaveAdditionalSettings"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const AddAnnouncement = async (data) => {
    const response = await Post(
      BaseURL("Announcement/AddAnnouncement"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const resendAnnouncement = async (data) => {
    const response = await Get(
      BaseURL(
        `Announcement/ResendAnnouncement?CommunityId=${data?.communityId}&AnnouncementId=${data?.announcementId}`
      ),
      accessToken
    );
    return response;
  };

  const generateBillReport = async (data) => {
    const response = await Post(
      BaseURL("Report/GenerateBillReport"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const maintenanceChargesReport = async (data) => {
    const response = await Post(
      BaseURL("Report/MaintenanceChargesReport"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const getReportLink = async (data) => {
    const response = await Post(
      BaseURL("Report/GetReportLink"),
      { ...data, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const getMyPaymentsListingHistory = async () => {
    const response = await Get(
      BaseURL(
        `FinancialTransaction/GetAllTransactionsByCommunityID?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const getPaymentReceiptReportApi = async (id) => {
    const response = await Get(
      BaseURL(`Report/GetPaymentReceiptReportByID?PaymentMasterID=${id}`),
      accessToken
    );
    return response;
  };

  const deleteAccountApi = async (params) => {
    const response = await Post(
      BaseURL("user/DeleteAccount"),
      { ...params, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const refreshUser = async () => {
    const response = await Get(BaseURL(`Auth/GetLoginFromToken?APPVersion=${Appversion}`), accessToken);
    return response;
  };

  const getAdditionalSettings = async (CommunityId) => {
    const response = await Get(
      BaseURL(`Setting/GetAdditionalSettings?CommunityId=${CommunityId}`),
      accessToken
    );
    return response;
  };

  const getAllHelpSubjectApi = async () => {
    const response = await Get(BaseURL(`Help/GetAllHelpSubject`), accessToken);
    return response;
  };

  const createHelpApi = async (params) => {
    const response = await Post(
      BaseURL("Help/CreateHelp"),
      { ...params, communityId },
      apiHeader(accessToken)
    );
    return response;
  };

  const getDashoboardNew = async () => {
    const response = await Post(
      BaseURL("Dashboard/GetDashboardCardCount_New"),
      {
        communityID: communityId,
        timeZone: moment.tz.guess(),
      },
      apiHeader(accessToken)
    );
    return response;
  };
  const cancelBooking = async (params) => {
    const response = await Post(
      BaseURL("Booking/CancelBooking"),
      {
        communityId: communityId,

        ...params,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const getExpenseReport = async (params) => {
    const response = await Post(
      BaseURL("Report/GetAllExpensesDetailByDateRange"),
      {
        communityId: communityId,
        timeZone: moment.tz.guess(),
        ...params,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const getIncomeExpenseReport = async (params) => {
    const response = await Post(
      BaseURL("Report/GetIncomeExpenseReport_New"),
      {
        communityID: communityId,
        timeZone: moment.tz.guess(),
        ...params,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const getDuesAndRecoveryReport = async () => {
    const response = await Get(
      BaseURL(
        `Report/DuesAndRecoverySummaryReport?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;
  };

  const getLedgerReportByDateRange = async (params) => {
    const response = await Post(
      BaseURL("Report/GetLedgerReportByDateRange"),
      {
        communityId: communityId,
        ...params
      },
      apiHeader(accessToken)
    );
    return response;
  }

  const getAllPaymentMode = async (params) => {
    const response = await Get(
      BaseURL(
        `Setup/GetAllPaymentMode`
      ),
      accessToken
    );
    return response;

  }


  const createWalletApi = async (params) => {
    const response = await Post(
      BaseURL("Wallet/CreateWallet"),
      {
        communityId: communityId,
        ...params
      },
      apiHeader(accessToken)
    );
    return response;
  }

  const onlinePaymentsApi = async (params) => {
    const response = await Post(
      BaseURL("PaymentCollection/OnlinePayment_URL"),
      {
        communityId: communityId,
        ...params
      },
      apiHeader(accessToken)
    );
    return response;
  }


  const changePlanApi = async (params) => {
    const response = await Get(
      BaseURL(
        `Setting/ChangePlan?CommunityId=${communityId}`
      ),
      accessToken
    );
    return response;

  }


  const addBeneficiaryAccountApi = async (params) => {
    const response = await Post(
      BaseURL("Wallet/AddBeneficiaryAccount"),
      {
        communityId: communityId,
        ...params
      },
      apiHeader(accessToken)
    );
    return response;

  }
  // wallets

  const getAllWalletTransactionApi = async (params) => {
    const response = await Post(
      BaseURL("Wallet/GetWalletTransactionListing"),
      params,
      apiHeader(accessToken)
    );
    return response;

  }

  const fetchBeneficiaryDetailsApi = async (params) => {
    const response = await Post(
      BaseURL("Wallet/FetchBeneficiaryDetail"),
      {
        communityId: communityId,
        ...params
      },
      apiHeader(accessToken)
    );
    return response;
  }

  const walletSendOtpApi = async (params) => {
    const response = await Post(
      BaseURL("Wallet/SendOTP"),
      {
        communityId: communityId,
        ...params
      },
      apiHeader(accessToken)
    );
    return response;

  }


  const getAllBanksAccountApi = async () => {
    const response = await Get(BaseURL("Setup/GetAllBank"), accessToken);
    return response;
  };


  const getDefaultBankBeneficiaryAccount = async () => {
    const response = await Get(BaseURL(`Wallet/GetDefaultBankBeneficiaryAccount?CommunityId=${communityId}`), accessToken);
    return response;
  };
  const beneficaryListingApi = async (data) => {
    const response = await Post(
      BaseURL("Wallet/GetBankBeneficaryListing"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };

  const updateBeneficaryApi = async (data) => {
    const response = await Post(
      BaseURL("Wallet/UpdateBeneficiary"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  };


  const deleteBeneficiaryApi = async (data) => {
    const response = await Post(
      BaseURL("Wallet/DeleteBeneficiary"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;

  }

  const walletWithdrawApi = async (data) => {
    const response = await Post(
      BaseURL("Wallet/Withdraw"),
      {
        ...data,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;
  }

  const checkWalletEnableApi = async (params) => {
    const response = await Post(
      BaseURL("Wallet/CheckWalletEnabled"),
      {
        ...params,
        communityId,
      },
      apiHeader(accessToken)
    );
    return response;

  }
  return {
    login,
    logout,
    generateOtp,
    signUp,
    resetPassword,
    RequestForgotOTP,
    verifyOtp,
    ForgotPassword,
    verifyCommunity,
    SaveAmmenityRanges,
    UploadAmmenitySeriesExcel,
    DownloadAmmenitySeriesExcel,
    GetAllAmmenities,
    GetAllPropertyType,
    joinCommunity,
    GetAmmenityDetailBySeriesDetailId,
    GetAllRole,
    GetAllDesignations,
    addUser,
    updateUser,
    getAllSeriesByCommunity,
    GetAllApprovalsListing,
    GetApprovalById,
    handleApprovalRequest,
    GetAllRoleListing,
    GetAllRoleModules,
    GetRoleById,
    UpdateRolePermission,
    SaveRolePermission,
    getAllAnnouncementListing,
    GetAllApprovalStatusListing,
    creatAnnouncement,
    deleteAnnouncement,
    getAnnouncementById,
    addOrEditAnnouncement,
    getAllCommunityServiceListing,
    addOrEditCommunityService,
    deleteCommunityService,
    deleteCommunityServiceCategory,
    getCommunityServiceById,
    getAllServicesType,
    GetAllUserListing,
    UpdateUserAccess,
    ChangePassword,
    UpdateProfile,
    getUserDetails,
    GetAllAmmenitiesListing,
    GetUserDetailByUserDetailId,
    // getAllParkingSeriesWithGroup,
    getAllSeriesByCommunityWithGroup,
    getProfileAnnouncementListing,
    SaveCommunityDetails,
    getAmenitySeriesByAmenityId,
    GetUserDetailsByCellno,
    GetAllBookingListing,
    addBooking,
    allotParking,
    getUserByRoleId,
    AddFinancialYear,
    AddNewBankAccount,
    GetAllAccountsListing,
    GetSingleAccountDetails,
    CheckCashAccountOpen,
    GetAllTransactionAccountsForDropdown,
    transferFunds,
    GetAllExpenseListing,
    GetSingleExpenseDetails,
    AddNewExpenseCategory,
    AddNewExpenseSubCategory,
    AddNewExpense,
    GetSingleAmenityListById,
    SaveAmenitySettings,
    GetMonthYearForDropdown,
    GetAllSeriesByCIdAIdMonthYear,
    GenerateMaintenance,
    GetMaintenanceCollectionListing,
    SubmitMaintenanceCollection,
    GetMaintenanceDetails,
    GetTransactionDetails,
    GetAllAmmenitiesWithCount,
    PaymentCollectionForBooking,
    GetAllAccountsBankAndCash,
    GetAllVisitorListing,
    addVisitor,
    updateVisitor,
    GetVisitorDetailByVisitorId,
    getAllStates,
    getAllCitiesByStateId,
    addUserWithRole,
    updateUserWithRole,
    addUserWithAmmenity,
    updateUserWithAmmenity,
    getDashboardStats,
    VerifyWaitList,
    GetVisitorListByCommunitySeriesDetailId,
    UpdateVisitStatusToArrived,
    UpdateVisitStatusToExit,
    getResidentPaymentsListing,
    SubmitResidentPaymentCollectionHandler,
    GetNotificationsList,
    GetAllPackages,
    GetPackageDetails,
    PayNowHandler,
    PayLaterHandler,
    VerifyPayment,
    GetAllComplainTypeListing,
    GetAllComplainStatusListing,
    addComplainHandler,
    GetAllComplainsListing,
    UpdateComplainStatus,
    GetComplainById,
    AddCommunityPolicy,
    GetCommunityPolicy,
    GetNotificationDropdown,
    GetAutoGenerateDropdown,
    SaveAdditionalSettings,
    AddAnnouncement,
    resendAnnouncement,
    generateBillReport,
    getReportLink,
    maintenanceChargesReport,
    getMyPaymentsListing,
    getMyPaymentsListingHistory,
    getPaymentReceiptReportApi,
    deleteAccountApi,
    waitListVerificationApi,
    VerifyWaitList,
    refreshUser,
    requestWaitListCode,
    getAdditionalSettings,
    getAllHelpSubjectApi,
    createHelpApi,
    getDashoboardNew,
    cancelBooking,
    getExpenseReport,
    getIncomeExpenseReport,
    getDuesReport: getDuesAndRecoveryReport,
    getLedgerReportByDateRange
    ,
    changePlanApi,
    getAllPaymentMode,
    createWalletApi,
    onlinePaymentsApi,
    addBeneficiaryAccountApi
    ,
    getAllWalletTransactionApi,
    fetchBeneficiaryDetailsApi,
    getAllBanksAccountApi,
    getDefaultBankBeneficiaryAccount,
    walletSendOtpApi
    ,
    beneficaryListingApi,
    updateBeneficaryApi,
    walletWithdrawApi,
    deleteBeneficiaryApi,
    checkWalletEnableApi,
    GetAllAccountsBankAndCashWithWallet

  };
};

export default useApi;
